import React from 'react';
import './styles/globals.css';
import Header from './components/Header';
import HeroNew from './components/HeroNew';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroNew />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;